import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextareaDrag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextareaDrag"><Path d="M22.0303 7.0293L7.03027 22.0293L5.96973 20.9688L20.9697 5.96875L22.0303 7.0293ZM22.0303 15.0293L15.0303 22.0293L13.9697 20.9688L20.9697 13.9688L22.0303 15.0293Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextareaDrag;
